import React from 'react';
import styled from 'styled-components';
import Info from './Info';
import Menu from './Menu';
import Navigation from './Navigation';
import Search from './Search';
import { useRouter } from 'next/router';

export default function Header(){
  const router = useRouter();
  const isOrder = router.pathname.includes('/order/');

  return <Container>
    <Info />
    <Menu isOrder={isOrder} />
    {!isOrder && <Search />}
    <Navigation />
  </Container>
}

const Container = styled.header`
  width: 100%;
`
